import React from 'react'

import { IconSVGProps } from '@sidecar-components/atoms/Icon/Icon.types'

export const Pills = ({
  className,
  pathClass,
  size = 6,
  ...rest
}: IconSVGProps) => (
  <svg
    aria-label="pills icon"
    className={`shrink-0 h-${size} w-${size} ${className}`}
    viewBox="0 0 48 48"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      className={pathClass}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.9385 13.3675H35.2615V10.4373L33.3231 10.4373L32.3538 10.4373L26.5385 10.4373V8.48383H32.3538V5.55359H16.8462V8.48383H18.7846V10.4373L16.8462 10.4373L15.8769 10.4373L13.9385 10.4373V13.3675ZM37.2 15.321H35.2615V43.6466C35.2615 44.7239 34.3921 45.6001 33.3231 45.6001H15.8769C14.8079 45.6001 13.9385 44.7239 13.9385 43.6466V15.321H12V8.48382H14.9077V5.55359C14.9077 4.47624 15.7771 3.6001 16.8462 3.6001H32.3538C33.4229 3.6001 34.2923 4.47624 34.2923 5.55359V8.48382H37.2V15.321ZM15.8769 15.321H33.3231V43.6466H15.8769V37.7861H28.4769V20.2047H15.8769V15.321ZM15.8769 22.1582V35.8326H26.5385V22.1582H15.8769Z"
    />
  </svg>
)
